import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, TextField } from '@mui/material';
import { Controller, useForm } from 'react-hook-form';
import Typography from '@mui/material/Typography';

export default function Email({ onSubmit, errorMessage }) {
  const { t } = useTranslation('home');
  const { control, handleSubmit } = useForm();
  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      style={{
        width: '100%',
        marginTop: '40px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
      }}
    >
      <section>
        <Controller
          name="email"
          style={{ width: '400px' }}
          render={({
            field: { onChange, value },
            fieldState: { error },
          }) => (
            <TextField
              value={value}
              type={'email'}
              onChange={onChange}
              data-cy="login-emailInput"
              error={!!error}
              helperText={error ? error.message : null}
              placeholder={t('login_mail_placeholder')}
            />
          )}
          control={control}
          defaultValue=""
          rules={{
            required: t('login_mail_required'),
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
              message: t('login_mail_pattern'),
            },
          }}
        />
      </section>
      <Button
        type="submit"
        data-cy="login-submitButton"
        style={{ marginTop: '30px' }}
        color="button"
        variant="contained"
      >
        {t('login_button')}
      </Button>
      {errorMessage?.length ? (
        <Typography
          data-cy="login-errorMessage"
          dangerouslySetInnerHTML={{
            __html: errorMessage.slice(0, 200),
          }}
          style={{
            marginTop: '10px',
            color: '#d32f2f',
            width: '100%',
            wordBreak: 'break-word',
          }}
        ></Typography>
      ) : (
        <></>
      )}
    </form>
  );
}
